import { Modal, Select, Input } from "antd";
import { updateProspectionStatus } from "../../api/prospections";
import { useState } from "react";

export default function ModalChangeStatus({ open, onClose, prospection, onSuccess }) {
  const [status, setStatus] = useState();
  const [commentaire, setCommentaire] = useState("");

  const handleOk = async () => {
    await updateProspectionStatus(prospection.id, {
      status,
      commentaire,
    });
    onSuccess();
    onClose();
  };

  return (
    <Modal title="Changer statut" open={open} onOk={handleOk} onCancel={onClose}>
      <Select
        style={{ width: "100%", marginBottom: 10 }}
        placeholder="Statut"
        onChange={setStatus}
      >
        <Select.Option value="EN_ATTENTE">En attente</Select.Option>
        <Select.Option value="RELANCE">À relancer</Select.Option>
        <Select.Option value="EN_COURS">En discussion</Select.Option>
        <Select.Option value="CONCLU">Conclu</Select.Option>
        <Select.Option value="PERDU">Perdu</Select.Option>
      </Select>

      <Input.TextArea
        placeholder="Commentaire"
        onChange={(e) => setCommentaire(e.target.value)}
      />
    </Modal>
  );
}
